import { IFireOutbreakRepository } from '../../domain/repositories/IFireOutbreak.repository'
import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { FireOutbreakRateInputDto } from '../../domain/dtos/FireOutbreakRateInput.dto'
import { GetFireOutbreaksInputDto } from '../../domain/dtos/GetFireOutbreaksInput.dto'
import { FireOutbreak } from '../../domain/entities/FireOutbreak'
import { FireOutbreakSchema } from './schemas/FireOutbreak.schema'
import { FireOutbreakClient } from './ports/FireOutbreakClient.abstract'

function parseFireOutbreakList(rawData: unknown): FireOutbreak[] {
	if (!Array.isArray(rawData)) return []

	const items: FireOutbreak[] = []
	rawData.forEach((item) => {
		const result = FireOutbreakSchema.safeParse(item)
		if (result.success) items.push(result.data)
	})
	return items
}

export class FireOutbreakRepositoryApiAdapter implements IFireOutbreakRepository {
	private _endpoint = '/v1/dashboard-risco-de-incendio'

	constructor(private _httpClient: FireOutbreakClient) {}

	async getMostRecentFireOutbreaks(input: GetFireOutbreaksInputDto): Promise<FireOutbreak[]> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-alertas-foco-de-incendio-por-intervalo-datas`,
			{
				params: {
					idArea: input.monitoredAreasIds,
					inicio: input.startDate?.slice(0, 10),
					fim: input.endDate?.slice(0, 10),
				},
				paramsSerializer: {
					indexes: null,
				},
			},
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível recuperar focos de incêndio')
		}

		return parseFireOutbreakList(response.data)
	}

	async rate(input: FireOutbreakRateInputDto): Promise<void> {
		const response = await this._httpClient.post(
			`${this._endpoint}/avaliar-alerta/${input.hash}?avaliacao=${input.rate}`,
			'',
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível avaliar ocorrência de foco de incêndio')
		}

		return
	}
}
